import { render, staticRenderFns } from "./MarkdownParser.vue?vue&type=template&id=4de893c8"
import script from "./MarkdownParser.vue?vue&type=script&lang=js"
export * from "./MarkdownParser.vue?vue&type=script&lang=js"
import style0 from "./MarkdownParser.vue?vue&type=style&index=0&id=4de893c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports